export var isBot = function (userAgent) {
    if (!userAgent)
        return false;
    var botPattern = /Chrome-Lighthouse/i;
    return botPattern.test(userAgent);
};
